import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import SwitchButton from 'modules/shift_management/components/ShiftManagement/SwitchButton'
import { useCurrentViewOptions } from 'modules/shift_management/hooks/useCurrentViewOptions'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { ScheduleOptions } from 'modules/shift_management/store/internal/models/ViewOptions'

interface Props {
  onChange: (option: keyof ScheduleOptions) => void
}

const ScheduleOptionsContent = ({ onChange }: Props) => {
  const [{ view }] = useSchedule()
  const { viewOptions } = useCurrentViewOptions()
  const { schedule } = viewOptions
  const {
    showCompactView,
    showName,
    showWorkplace,
    showWorkArea,
    showOvertime,
    showBreaks,
    showNotes,
  } = schedule

  const disabled = showCompactView

  return (
    <>
      <Box paddingBottom="s8" paddingLeft="s12" paddingRight="s12" paddingTop="s12">
        <Text className="text-f1-foreground-secondary" size="100" weight="medium">
          {i18n.t('shift_management.view_options.titles.new_schedule')}
        </Text>
      </Box>

      <Box paddingBottom="s12" paddingLeft="s12" paddingRight="s12" paddingTop="s8" gap="s16">
        <SwitchButton
          onChange={() => onChange('showCompactView')}
          checked={showCompactView}
          id="showCompactView"
          title={i18n.t('shift_management.view_options.compactView')}
        />
        {view.isFullVersion && (
          <>
            <SwitchButton
              onChange={() => onChange('showName')}
              checked={showName}
              id="showName"
              title={i18n.t('shift_management.view_options.name')}
              disabled={disabled}
            />
            <SwitchButton
              onChange={() => onChange('showWorkplace')}
              checked={showWorkplace}
              id="showWorkplace"
              title={i18n.t('shift_management.view_options.workplace')}
              disabled={disabled}
            />
            <SwitchButton
              onChange={() => onChange('showWorkArea')}
              checked={showWorkArea}
              id="showWorkArea"
              title={i18n.t('shift_management.view_options.workArea')}
              disabled={disabled}
            />
            <SwitchButton
              onChange={() => onChange('showOvertime')}
              checked={showOvertime}
              id="showOvertime"
              title={i18n.t('shift_management.view_options.overtime')}
              disabled={disabled}
            />
          </>
        )}
        <SwitchButton
          onChange={() => onChange('showBreaks')}
          checked={showBreaks}
          id="showBreaks"
          title={i18n.t('shift_management.view_options.breaks')}
          disabled={disabled}
        />
        <SwitchButton
          onChange={() => onChange('showNotes')}
          checked={showNotes}
          id="showNotes"
          title={i18n.t('shift_management.view_options.notes')}
          disabled={disabled}
        />
      </Box>
    </>
  )
}

export default observer(ScheduleOptionsContent)
